import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function SystemBreakdown() {
  const steps = [{
    letter: 'A',
    title: 'Ancla mental',
    desc: 'Dejas de negociar contigo cada mañana. Reglas simples para estabilizarte.'
  }, {
    letter: 'G',
    title: 'Gestión de energía',
    desc: 'Sin energía no hay decisiones. Solo hay supervivencia fea.'
  }, {
    letter: 'U',
    title: 'Umbrales',
    desc: 'Detectas el “amarillo” antes del “rojo”. Límites antes del quiebre.'
  }, {
    letter: 'A',
    title: 'Acciones pequeñas',
    desc: 'Microacciones que cambian tu semana (sin depender de motivación).'
  }, {
    letter: 'N',
    title: 'No‑drama',
    desc: 'Te proteges: no explotas, no confiesas, no te regalas al conflicto.'
  }, {
    letter: 'T',
    title: 'Transición',
    desc: 'Dos rutas realistas: cambio lateral rápido o salida total gradual.'
  }, {
    letter: 'A',
    title: 'Archivo de evidencias',
    desc: 'Orden y documentación para claridad y protección.'
  }];
  return <Section variant="darker" className="border-t border-neutral-900" data-id="element-134">
      <div className="mb-12" data-id="element-135">
        <h2 className="text-3xl font-bold text-white uppercase tracking-tight mb-4" data-id="element-136">
          El mecanismo:{' '}
          <span className="text-red-600" data-id="element-137">Sistema A.G.U.A.N.T.A.</span>
        </h2>
        <p className="text-neutral-400" data-id="element-138">
          La mayoría falla porque intenta arreglarlo todo a la vez. Tú vas a
          seguir este orden:
        </p>
      </div>

      <div className="relative border-l-2 border-neutral-800 ml-4 md:ml-6 space-y-8 py-2" data-id="element-139">
        {steps.map((step, i) => <motion.div key={i} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="relative pl-8 md:pl-12" data-id="element-140">
            <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-neutral-900 border-2 border-red-600" data-id="element-141" />

            <div className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-4" data-id="element-142">
              <h3 className="text-2xl font-black text-red-600 w-8" data-id="element-143">
                {step.letter}
              </h3>
              <div data-id="element-144">
                <h4 className="text-xl font-bold text-white mb-1" data-id="element-145">
                  {step.title}
                </h4>
                <p className="text-neutral-400 leading-relaxed" data-id="element-146">{step.desc}</p>
              </div>
            </div>
          </motion.div>)}
      </div>

      <div className="mt-12 bg-neutral-900 p-4 rounded text-center text-neutral-400 text-sm" data-id="element-147">
        Y al final: <strong className="text-white" data-id="element-148">ajuste semanal</strong> para
        no volver al mismo hoyo.
      </div>
    </Section>;
}